module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8PsZM"))).then(() => module.bundle.root('ewmtE'));